import {
  LOAN_STATUS,
  LOAN_REQUEST_STATUS,
  LOAN_REQUEST_TYPE,
  LOAN_COMMISION_STATUS,
} from '../constants/loan.js';

export const getStatusDisplayText = (status) => {
  switch (status) {
    case LOAN_STATUS.ACTIVE:
      return 'Active';
    case LOAN_STATUS.LOST:
      return 'Lost';
    case LOAN_STATUS.PAST_DUE:
      return 'Past due';
    case LOAN_STATUS.MISSED:
      return 'Missed';
    case LOAN_REQUEST_STATUS.CREATED_UNSUBMITTED:
      return 'Unsubmitted';
    case LOAN_REQUEST_STATUS.PRE_APPROVED:
      return 'Pre-approved';
    case LOAN_REQUEST_STATUS.SUBMITTED_FOR_REVIEW:
      return 'Submitted';
    case LOAN_REQUEST_STATUS.OFFER_REJECTED:
    case LOAN_REQUEST_STATUS.REJECTED:
      return 'Declined';
    case LOAN_REQUEST_STATUS.OFFER_ACCEPTED:
    case LOAN_REQUEST_STATUS.ACCEPTED_FOR_PROCESSING:
      return 'Processing';
    case LOAN_STATUS.AWAITING_DISBURSEMENT:
      return 'Awaiting disbursement';
    case LOAN_REQUEST_STATUS.TRANSACTION_LOST:
      return 'Transaction lost';
    default:
      return status;
  }
};

export const getStatusClasses = (status) => {
  switch (status) {
    case LOAN_REQUEST_STATUS.CREATED_UNSUBMITTED:
    case LOAN_REQUEST_STATUS.SUBMITTED_FOR_REVIEW:
    case LOAN_REQUEST_STATUS.PRE_APPROVED:
    case LOAN_REQUEST_STATUS.OFFER_ACCEPTED:
    case LOAN_REQUEST_STATUS.ACCEPTED_FOR_PROCESSING:
    case LOAN_STATUS.AWAITING_DISBURSEMENT:
      return 'badge-processing';
    case LOAN_REQUEST_STATUS.ARCHIVED:
    case LOAN_REQUEST_STATUS.EXPIRED:
    case LOAN_STATUS.RESTRUCTURED:
      return 'badge-archived-expired';
    case LOAN_REQUEST_STATUS.OFFER_REJECTED:
    case LOAN_REQUEST_STATUS.REJECTED:
    case LOAN_REQUEST_STATUS.CANCELLED:
    case LOAN_REQUEST_STATUS.TRANSACTION_LOST:
      return 'badge-declined';
    case LOAN_STATUS.ACTIVE:
    case LOAN_COMMISION_STATUS.DUE:
      return 'badge-active';
    case LOAN_REQUEST_STATUS.APPROVED:
    case LOAN_REQUEST_STATUS.CONVERTED:
    case LOAN_STATUS.REPAID:
    case LOAN_COMMISION_STATUS.PAID:
      return 'badge-loan-success';
    case LOAN_STATUS.PAST_DUE:
    case LOAN_STATUS.LOST:
      return 'badge-lost';
    default:
      return 'badge-default';
  }
};

export const getTypeShortText = (loanType) => {
  switch (loanType) {
    case LOAN_REQUEST_TYPE.LPO:
      return 'LPO';
    case LOAN_REQUEST_TYPE.IDF:
      return 'IDF';
    case LOAN_REQUEST_TYPE.LEASE_FINANCE:
      return 'LF';
    case LOAN_REQUEST_TYPE.WORKING_CAPITAL:
      return 'WC';
    case LOAN_REQUEST_TYPE.OTHERS:
      return 'Others';
    default:
      return '--';
  }
};

export const getCommisionStatusDisplayText = (status) => {
  switch (status) {
    case LOAN_COMMISION_STATUS.DUE:
      return 'Due';
    case LOAN_COMMISION_STATUS.NOT_DUE:
      return 'Not due';
    case LOAN_COMMISION_STATUS.PAID:
      return 'Paid';
    default:
      return status;
  }
};
